import React from "react";

export function TargetLogo({ size = 40 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden>
      <circle cx="24" cy="24" r="19" stroke="#E11D2E" strokeWidth="4" />
      <circle cx="24" cy="24" r="9" stroke="#E11D2E" strokeWidth="4" />
      <circle cx="24" cy="24" r="2.5" fill="#E11D2E" />
      <path d="M24 0v10M24 38v10M0 24h10M38 24h10" stroke="#E11D2E" strokeWidth="3.5" strokeLinecap="round" />
    </svg>
  );
}

export function BrandMark({ light = true, compact = false }: { light?: boolean; compact?: boolean }) {
  return (
    <span className="flex items-center gap-3">
      <TargetLogo size={compact ? 32 : 40} />
      <span
        className={`font-extrabold uppercase leading-[1.1] tracking-tight ${
          light ? "text-white" : "text-ink"
        } ${compact ? "text-sm" : "text-base"}`}
      >
        GRS Shoot
        <br />
        Results Portal
      </span>
    </span>
  );
}
